export default __webpack_public_path__ + "static/media/SWT1360.34I-41619_-24892_0.fe895080.jpg";